import { affiliateControlContract } from './affiliatecontrol';
import { affilkaContract, affilkaNativeContract } from './affilka';
import { affiseContract } from './affise';
import { cellxpertContract, cellxpertNativeContract } from './cellxpert';
import { cparoundContract } from './cparound';
import { customContract } from './custom';
import { everflowContract } from './everflow';
import { keitaroContract } from './keitaro';
import { myaffiliatesBackofficeContract, myaffiliatesContract } from './myaffiliates';
import { referonBuilderContract, referonContract } from './referon';
import { traffickongContract } from './traffickong';
/**
 * All platform contracts, keyed by id.
 *
 * The ten ids matching backoffice `PLATFORMS` (cellxpert, affilka, referon,
 * affise, traffickong, cparound, keitaro, everflow, myaffiliates, custom) are
 * the ones the equivalence test suite is required to cover. `cellxpert-native`
 * and `affiliatecontrol` are additional contracts grounded directly in server
 * DTOs/mappers/backlog tasks, kept for the pitfall tests and the drift table;
 * they are not part of the "one entry per backoffice PLATFORMS id" requirement.
 *
 * `referon-builder`, `affilka-native` and `myaffiliates-backoffice` are
 * ADDITIVE, requested by the surface-migration cycle (track-i-surfaces):
 * each reproduces one surface's CURRENT byte-for-byte output on a
 * (platform, event) combination where that surface's output deliberately
 * diverges from this package's canonical contract (see the drift table in
 * docs/solutions/postback-contract-registry.md). They exist so a surface can
 * migrate to sourcing its links from this package without silently changing
 * what it renders — the decision to switch a surface over to the canonical
 * variant stays an explicit, separate call for the project owner.
 */
export const ALL_CONTRACTS = {
    [cellxpertContract.id]: cellxpertContract,
    [cellxpertNativeContract.id]: cellxpertNativeContract,
    [affilkaContract.id]: affilkaContract,
    [affilkaNativeContract.id]: affilkaNativeContract,
    [referonContract.id]: referonContract,
    [referonBuilderContract.id]: referonBuilderContract,
    [affiseContract.id]: affiseContract,
    [traffickongContract.id]: traffickongContract,
    [cparoundContract.id]: cparoundContract,
    [keitaroContract.id]: keitaroContract,
    [everflowContract.id]: everflowContract,
    [myaffiliatesContract.id]: myaffiliatesContract,
    [myaffiliatesBackofficeContract.id]: myaffiliatesBackofficeContract,
    [customContract.id]: customContract,
    [affiliateControlContract.id]: affiliateControlContract,
};
/** The 10 ids matching backoffice's `PLATFORMS` array, in its declared order. */
export const BACKOFFICE_PLATFORM_IDS = [
    'cellxpert',
    'affilka',
    'referon',
    'affise',
    'traffickong',
    'cparound',
    'keitaro',
    'everflow',
    'myaffiliates',
    'custom',
];
export { affiliateControlContract, affilkaContract, affilkaNativeContract, affiseContract, cellxpertContract, cellxpertNativeContract, cparoundContract, customContract, everflowContract, keitaroContract, myaffiliatesBackofficeContract, myaffiliatesContract, referonBuilderContract, referonContract, traffickongContract, };
//# sourceMappingURL=index.js.map